/** RPA use-case domains (Document AI + RPA, RPA + Workflow Automation). */
export const RPA_DOMAINS = [
  { id: "financial-domain", slug: "financial-domain", label: "Financial Domain", live: true },
  { id: "manufacturing", slug: "manufacturing", label: "Manufacturing", live: true },
  { id: "hr-domain", slug: "hr-domain", label: "HR Domain", live: true },
  { id: "healthcare-domain", slug: "healthcare-domain", label: "Healthcare", live: true },
  { id: "logistics-domain", slug: "logistics-domain", label: "Logistics", live: true },
  { id: "retail-domain", slug: "retail-domain", label: "Retail", live: true },
  { id: "insurance-domain", slug: "insurance-domain", label: "Insurance", live: true },
  { id: "telecom-domain", slug: "telecom-domain", label: "Telecom", live: true },
  { id: "energy-utilities-domain", slug: "energy-utilities-domain", label: "Energy & Utilities", live: true },
  { id: "public-sector-government-domain", slug: "public-sector-government-domain", label: "Public Sector & Government", live: true },
  { id: "real-estate-construction-domain", slug: "real-estate-construction-domain", label: "Real Estate & Construction", live: true },
  { id: "education-domain", slug: "education-domain", label: "Education", live: true },
  { id: "hospitality-travel-domain", slug: "hospitality-travel-domain", label: "Hospitality & Travel", live: true },
  { id: "media-entertainment-domain", slug: "media-entertainment-domain", label: "Media & Entertainment", live: true },
  { id: "agriculture-food-processing-domain", slug: "agriculture-food-processing-domain", label: "Agriculture & Food Processing", live: true },
  { id: "it-technology-services-domain", slug: "it-technology-services-domain", label: "IT & Technology Services", live: true },
  { id: "aviation-aerospace-domain", slug: "aviation-aerospace-domain", label: "Aviation & Aerospace", live: true },
];

export const RPA_USE_CASES_LABEL = "RPA Use Cases";

export const RPA_DROPDOWN = [
  "RPA Services",
  "Case Studies",
  "Demo Videos",
  RPA_USE_CASES_LABEL,
];

export const isRpaDomainLabel = (label) =>
  RPA_DOMAINS.some((d) => d.label === label);

export const rpaPathFromLabel = (label) => {
  const domain = RPA_DOMAINS.find((d) => d.label === label);
  return domain ? `/rpa-use-cases/${domain.slug}` : "/rpa-use-cases";
};

